export default "__VITE_ASSET__26934707__"